import { axiosInstance, risingInstance } from "../baseApi";
import { getRisingToken, getRisingUserInfo } from "../authToken";
const authUrl = process.env.VUE_APP_BOT_URL;
axiosInstance.defaults.headers["SECRET-KEY"] = process.env.VUE_APP_BOT_SECRET;

// 코인리스트
export async function getCoinList() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/coin?wht=binance`;

  return axiosInstance.get(`${url}`);
}

// 레퍼럴 연동 여부 체크
export async function getReferralChk(user) {
  let url = `/grid-bot/check-exchange`;
  let params = {
    user_no: user,
  };

  return axiosInstance.get(`${authUrl}${url}`, {
    params: params,
  });
}

// api 연동여부 체크
export async function getAPICheck(user) {
  let url = "/user/api-key";
  let params = {
    user_no: user,
    exchange: 1,
  };

  return axiosInstance.get(`${authUrl}${url}`, {
    params: params,
  });
}

// 봇 잔고 불러오는 api
export async function getBalance(user) {
  let url = "/user/balance";
  let params = {
    user_no: user,
    exchange: 1,
    limit: 1,
  };

  return axiosInstance.get(`${authUrl}${url}`, {
    params: params,
  });
}

// api 연동
export async function postAPICheck(user, access, secret) {
  let url = "/user/api-key";
  return axiosInstance.post(
    `${authUrl}${url}`,
    {
      access_key: access,
      secret_key: secret,
      passphrase: "",
      user_no: user,
      exchange: 1,
    }
  );
}

// api 연동 삭제
export async function removeAPICheck(user) {
  let url = "/user/api-key";
  return axiosInstance.delete(`${authUrl}${url}`, {
    data: {
      user_no: user,
      exchange: 1,
    },
  });
}

// 그리드봇 데이터
export async function getGridInfoAPI(user, symbol) {
  let url = "/grid-bot/view";
  let params;

  if (symbol) {
    params = {
      user_no: user,
      exchange: 1,
      symbol: symbol,
    };
  } else {
    params = {
      user_no: user,
      exchange: 1,
    };
  }

  return axiosInstance.get(`${authUrl}${url}`, {
    params: params
  });
}

// 그리드봇 레벨 데이터
export async function getDetailAPI(user, coin) {
  let url = "/grid-bot/grid-levels";
  return axiosInstance.get(`${authUrl}${url}`, {
    params: {
      user_no: user,
      symbol: coin,
    }  
  });
}

// 그리드봇 세팅
export async function gridSetAPI(info) {
  // console.log('1', info.investment)
  // console.log('2', info.position)
  // console.log('3', info.coin)
  // console.log('4', info.take_profit_per)
  // console.log('5', info.stop_loss_per)
  // console.log('6', info.leverage)
  // console.log('6', info.user)

  let url = "/grid-bot/settings";



  return axiosInstance.post(
    `${authUrl}${url}`,
    {
      investment: String(info.investment),
      trade_mode: info.position,
      symbol: info.coin,
      profit: String(info.take_profit_per),
      loss: String(info.stop_loss_per),
      leverage: info.leverage,
      user_no: String(info.user),
      exchange: 1,
    }
  );
}

// 그리드봇 시작/정지
export async function gridActiveAPI(user, symbol, active) {
  let url = "/grid-bot/active";
  console.log(232323, user, symbol, active);
  return axiosInstance.post(
    `${authUrl}${url}`,
    {
      user_no: user,
      symbol: symbol,
      active: active,
      exchange: 1,
    }
  );
}

// 그리드봇 삭제
export async function gridCloseAPI(user, symbol) {
  let url = "/grid-bot/close";
  return axiosInstance.delete(`${authUrl}${url}`, {
    data: {
      user_no: user,
      symbol: symbol,
      exchange: 1,
    }
  });
}
